import { BenchmarkingReportSettings, BenchmarkingDisplay } from '@/hooks'

export const shouldDisplayAreaSetting = (
    reportSettings: BenchmarkingReportSettings
) => {
    const { basis, display } = reportSettings

    const compatibleEntities: BenchmarkingDisplay[] = ['facility', 'group']

    if (basis === 'costPerUsage') {
        return false
    }

    if (!compatibleEntities.includes(display)) {
        return false
    }

    return true
}
